import React, {useState, useCallback} from 'react';
import {UploadFile} from '@/components/molecules';
import {Constants} from '@/utils/constants/commonConstants';
import {Toggle} from '@/components/atoms';

export const ImageOptimization = () => {
  const [formData, setFormData] = useState('');
  const [toggleValue, setToggleValue] = useState(false);
  const [imgUrl, setImgUrl] = useState('');
  const [orgUrl, setOrgUrl] = useState('');
  const [imgSize, setImgSize] = useState('');
  const [imgSizeNew, setImgSizeNew] = useState('');
  const [uploading, setUploading] = useState(false);
  const [value, setValue] = useState({height: '', width: ''});

  const handleDelete = useCallback(() => {
    setFormData((prev) => ({...prev, ...{targetMediaFile: []}}));
  }, []);

  const convertFileToImageurl = useCallback((file) => {
    setOrgUrl(URL.createObjectURL(file));
  }, []);

  const convertBlobToFile = useCallback((blob, fileName) => {
    const file = new File([blob], fileName, {
      type: blob.type,
      lastModified: Date.now()
    });
    setImgSizeNew(file?.size);
    return file;
  }, []);

  const convertImageToWebP = useCallback(
    async (file) => {
      setImgSize(file?.size);
      const imageUrl = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (event) => {
          const img = new Image();
          img.onload = () => {
            const canvas = document.createElement('canvas');
            canvas.width = img.width;
            canvas.height = img.height;
            const ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0);
            canvas.toBlob(
              (blob) => {
                if (blob) {
                  resolve(blob);
                } else {
                  reject(new Error('Conversion to WebP failed'));
                }
              },
              'image/webp',
              0.7 // Quality parameter from 0 to 1
            );
          };
          img.src = event.target.result;
        };
        reader.readAsDataURL(file);
      });
      convertBlobToFile(imageUrl, file.name);
      const url = URL.createObjectURL(imageUrl);
      setImgUrl(url);
    },
    [convertBlobToFile]
  );

  const onUpdate = useCallback((e) => {
    const {name, value} = e.target;
    setValue((prevValue) => ({
      ...prevValue,
      [name]: value
    }));
  }, []);

  return (
    <div>
      <div className='flex justify-between'>
        <div>
          <div>Before</div>
          <img src={orgUrl} alt='Before optimization' />
          <span>{imgSize}</span>
        </div>
        <div>
          <div>After</div>
          <img
            style={{
              maxWidth: value.width ? `${value.width}px` : '300px',
              maxHeight: value.height ? `${value.height}px` : '300px',
              width: '100%',
              height: '100%',
              objectFit: 'contain',
              imageRendering: 'auto'
            }}
            src={imgUrl}
            alt='After optimization'
          />
          <span>{imgSizeNew}</span>
        </div>
      </div>
      <div className='mt-12 flex flex-col items-center justify-center'>
        <UploadFile
          acceptedExtensions={'.png'}
          description={'test'}
          label={Constants.UploadStoresFile}
          variant={Constants.Edit}
          feedbackType={Constants.Info}
          required={true}
          files={
            formData?.targetMediaFile?.length > 0
              ? [formData?.targetMediaFile]
              : []
          }
          onUpload={(file) => {
            setFormData((prev) => ({
              ...prev,
              ...{targetMediaFile: [file?.name]}
            }));
            convertImageToWebP(file);
            convertFileToImageurl(file);
          }}
          onUploadDelete={handleDelete}
          // helperText={uploadError ? 'File format is not valid. Supported formats: .csv' : ''}

          type={Constants.Single}
          showDownloadTemplate={false}
          showHandleViewTable={false}
          className={formData?.targetMediaFile?.length > 0 ? 'disabled' : ''}
          containerClassName={
            formData?.targetMediaFile?.length > 0 ? 'disabled' : ''
          }
          dataTestId='upload-file'
          uploading={uploading}
          setUploading={setUploading}
        />
        <div className='mt-12'>
          <Toggle
            uiSchema={{
              isDark: true,
              label: 'is width and height manual',
              size: 'medium'
            }}
            updateValue={() => setToggleValue(!toggleValue)}
            value={toggleValue}
          />
          {toggleValue && (
            <div className=' flex flex-col'>
              <input
                onChange={onUpdate}
                type='text'
                placeholder='enter your image width'
                value={value.width}
                className='mt-8 text-black'
                name='width'
              />
              <input
                onChange={onUpdate}
                type='text'
                placeholder='enter your image height'
                value={value.height}
                className='mt-8 text-black'
                name='height'
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

ImageOptimization.propTypes = {
  // This component doesn't accept props as it manages its own state internally
  // PropTypes are defined here for documentation purposes but won't be enforced
};

ImageOptimization.defaultProps = {
  // No default props needed as component manages its own state
};

export default React.memo(ImageOptimization);
